"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getLandingPageStockpile = exports._getTransactStockpile = exports._createTransactionStockpile = exports._getDumpTruckByNo = exports._getMasterDumpTruck = exports._getTripDumpTruck = exports._postLEDStockpileConfig = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const dataError = {
    id: '',
    shift: 0,
    pos_id: '',
    pit_id: '',
    area_id: '',
    seam_id: '',
    pos_name: '',
    penalty: '',
    rfid_tag: '',
    brand_id: '',
    pit_name: '',
    total_trip: 0,
    ticket_no: '',
    area_name: '',
    seam_name: '',
    brand_name: '',
    created_by: '',
    nett_volume: 0,
    dumptruck_id: '',
    brand_color: '',
    modified_by: '',
    dumptruck_no: '',
    excavator_id: '',
    excavator_no: '',
    is_active: false,
    contractor_id: '',
    capacity_volume: 0,
    contractor_name: '',
    time_in: new Date(),
    date_in: new Date(),
    gate_in: new Date(),
    gate_out: new Date(),
    transaction_type: '',
    created_date: new Date(),
    modified_date: new Date(),
    image_penalty_evidence: '',
    main_entrance_in: new Date(),
};
const _postLEDStockpileConfig = (payload) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/adjustment/LEDSign';
    try {
        const { data } = yield axios_1.default.post(url, payload, {
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            },
        });
        return {
            isError: data.isError,
            message: data.message,
        };
    }
    catch (e) {
        const err = (0, error_response_1.errorResponse)(e);
        return {
            isError: err.isError,
            message: err.errorMessage,
        };
    }
});
exports._postLEDStockpileConfig = _postLEDStockpileConfig;
const _getTripDumpTruck = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/dumptruck-trip/${args}`;
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, totalTrip: 'X', countData: 0 };
    }
});
exports._getTripDumpTruck = _getTripDumpTruck;
const _getMasterDumpTruck = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/dumptruck-rfid/${args}`;
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: dataError, countData: 0 };
    }
});
exports._getMasterDumpTruck = _getMasterDumpTruck;
const _getDumpTruckByNo = (args) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/master-data/dumptruck-no/${args}`;
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: dataError, countData: 0 };
    }
});
exports._getDumpTruckByNo = _getDumpTruckByNo;
const _createTransactionStockpile = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + '/transaction/stockpile';
    const config = {
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
        },
    };
    try {
        const { data } = yield axios_1.default.post(url, arg, config);
        return {
            isError: data.isError,
            errorMessage: data.errorMessage,
            errorCode: data.errorCode,
            countData: data.countData,
            data: {
                id: data.data.id,
            },
        };
    }
    catch (e) {
        const response = (0, error_response_1.errorResponse)(e);
        return Object.assign(Object.assign({}, response), { isError: response.isError, countData: 0, errorMessage: response.errorMessage, data: {
                id: '',
            } });
    }
});
exports._createTransactionStockpile = _createTransactionStockpile;
const _getTransactStockpile = ({ skip, take, filter, sort }) => __awaiter(void 0, void 0, void 0, function* () {
    const filterString = filter ? JSON.stringify(filter) : undefined;
    const sortString = sort ? sort.length > 0 ? JSON.stringify(sort) : undefined : undefined;
    const url = String(process.env.API_ENDPOINT) + '/transaction/stockpile';
    const config = {
        params: { skip, take, filter: filterString, sort: sortString },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return { isError, errorCode, errorMessage, data: [], countData: 0 };
    }
});
exports._getTransactStockpile = _getTransactStockpile;
const _getLandingPageStockpile = ({ checkpoint_id }) => __awaiter(void 0, void 0, void 0, function* () {
    const url = String(process.env.API_ENDPOINT) + `/user/checkpointUser/page/${checkpoint_id}`;
    const config = {
        params: { type: 'stockpile', skip: 0, take: 10 },
        headers: {
            'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token()
        }
    };
    try {
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            errorMessage,
            countDataTransaction: 0,
            data: {
                DeviceData: [],
                countDataTransaction: 0,
                TransactionDataStockpile: [],
                ConfigurationCheckPointData: {
                    id: '',
                    type: '',
                    brand1_id: '',
                    brand2_id: '',
                    brand3_id: '',
                    brand4_id: '',
                    brand5_id: '',
                    brand1_name: '',
                    brand2_name: '',
                    brand3_name: '',
                    brand4_name: '',
                    brand5_name: '',
                    brand1_color: '',
                    brand2_color: '',
                    brand3_color: '',
                    brand4_color: '',
                    brand5_color: '',
                    dumping_type: '',
                    checkpoint_id: '',
                    checkpoint_name: '',
                    dumping_type_id: '',
                }
            }
        };
    }
});
exports._getLandingPageStockpile = _getLandingPageStockpile;
